import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Modèle représentant un contrat
 */
export class Contrat implements ListItem{
    idContrat: number;
    numero: string;
    libelle: string;
    commentaire: string;
    idFormatCarte: number;
    idFormatFacture: number;
    creationAuto: boolean;
    idTypeEntite: number;
    idStatutValide: number;
    idStatutErreur: number;
    idFournisseur: number;
    typeImport: TypeImport;
    libelleImport: string;
    typeDebit: TypeDebit;
    dateDebut: Date;
    dateFin: Date;

    constructor(dto: any) {

        if (dto) {
            this.idContrat = dto.idContrat;
            this.numero = dto.numero;
            this.libelle = dto.libelle;
            this.commentaire = dto.commentaire;
            this.idFormatCarte = dto.idFormatCarte;
            this.idFormatFacture = dto.idFormatFacture;
            this.creationAuto = dto.creationAuto;
            this.idTypeEntite = dto.idTypeEntite;
            this.idStatutValide = dto.idStatutValide;
            this.idStatutErreur = dto.idStatutErreur;
            this.idFournisseur = dto.idFournisseur;
            this.typeImport = dto.typeImport;
            this.libelleImport = dto.libelleImport;
            this.typeDebit = dto.typeDebit;
            this.dateDebut = dto.dateDebut;
            this.dateFin = dto.dateFin;
        }
    }

    /**
     * Récupération de l'identifiant de l'objet
     * @returns L'identifiant du contrat
     */
    getKey(): number | string {
        return this.idContrat;
    }

}

/**
 * Enum des types de débit
 */
export enum TypeDebit {
    SOCIETE = "SOCIETE",
    COLLAB = "COLLAB"
}

/**
 * Enum des types d'import
 */
export enum TypeImport {
    CARTE = "CARTE",
    FACTURE = "FACTURE"
}